import React, { useState } from "react";
import Content from "../components/Programs/Content";
import Aside from "../modules/SideNav/Aside";
import Approvals from "../pages/Approvals/Approvals";

function ApprovalsLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      <Approvals handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default ApprovalsLayout;
